import type { CSSProperties } from "react";
import { cx } from "../utils/cx";

export interface SkeletonProps {
  readonly variant?: "text" | "rect" | "circle";
  /** CSS size values, e.g. "12rem", "100%", 48. */
  readonly width?: string | number;
  readonly height?: string | number;
  readonly className?: string;
}

/** Skeleton loader — §14.3: skeletons preferred over spinners. */
export function Skeleton({ variant = "text", width, height, className }: SkeletonProps) {
  const style: CSSProperties = {};
  if (width !== undefined) style.inlineSize = width;
  if (height !== undefined) style.blockSize = height;
  if (variant === "circle" && height === undefined && width !== undefined) style.blockSize = width;
  return <span className={cx("ui-skeleton", `ui-skeleton--${variant}`, className)} style={style} aria-hidden="true" />;
}
